"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebAppRootWithHero = void 0;
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useAppState_1 = __importDefault(require("@opsbase/web-app-state/useAppState"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const react_1 = __importDefault(require("react"));
const useWindowResize_1 = __importDefault(require("../useWindowResize"));
const WebAppFooter_1 = __importDefault(require("./WebAppFooter"));
const makeMyClasses = () => ({
    root: {
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: lib_palette_1.default.White.main,
    },
});
function WebAppRootWithHero(props) {
    const { children } = props;
    const { hero } = (0, useAppState_1.default)();
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const hideGraphic = (0, useWindowResize_1.default)().width <= 760;
    return (react_1.default.createElement("div", { className: myCss.root },
        react_1.default.createElement(Vertical_1.default, null,
            react_1.default.createElement(Horizontal_1.default, { gutter: true, style: { height: '100%' } },
                !hideGraphic && (react_1.default.createElement("div", { style: {
                        width: '50%',
                        height: '100%',
                        display: 'flex',
                        backgroundColor: lib_palette_1.default.BackgroundGrey.main,
                    } },
                    react_1.default.createElement("img", { style: {
                            alignSelf: 'center',
                            width: '80%',
                            aspectRatio: '1',
                            margin: 'auto',
                        }, src: hero, alt: lib_i18n_1.default.t('opsbase') }))),
                react_1.default.createElement(Pane_1.default, { grow: true, style: { display: 'flex', overflow: 'auto' } },
                    react_1.default.createElement("div", { style: {
                            margin: 'auto',
                            paddingLeft: 5,
                            paddingRight: 5,
                        } }, children))),
            react_1.default.createElement(WebAppFooter_1.default, null))));
}
exports.WebAppRootWithHero = WebAppRootWithHero;
exports.default = WebAppRootWithHero;
